import React, { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import { DEFAULT_SITE_SETTINGS } from '../../../config/siteSettings';
import { requestJson } from './request';

const fields = [
  ['contact_phone', '대표 전화', '010-0000-0000', 'tel'],
  ['contact_email', '대표 이메일', 'info@example.com', 'email'],
  ['contact_email_secondary', '보조 이메일', 'sales@example.com', 'email'],
  ['contact_address', '주소', '서울시 ...', 'text'],
  ['business_hours', '업무 시간', '평일 09:00 - 18:00', 'text'],
  ['lunch_hours', '점심 시간', '12:00 - 13:00', 'text'],
] as const;

export default function ContactSettingsPanel() {
  const [form, setForm] = useState(DEFAULT_SITE_SETTINGS);
  const [status, setStatus] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    requestJson('/api/settings').then(data => setForm(current => ({ ...current, ...data }))).catch(error => setStatus(error.message));
  }, []);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault(); setSaving(true); setStatus('');
    try {
      await requestJson('/api/settings', { method: 'POST', body: JSON.stringify(form) });
      setStatus('연락처 설정을 저장했습니다.');
    } catch (error) { setStatus((error as Error).message); }
    finally { setSaving(false); }
  };

  return (
    <form onSubmit={submit} className="max-w-4xl mx-auto px-4 py-8">
      <div className="mb-7"><h2 className="text-xl font-bold text-stone-900">공개 연락처 정보</h2><p className="text-sm text-stone-500 mt-1">연락처 페이지와 검색엔진 구조화 데이터에 동일하게 사용됩니다.</p></div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 bg-white border border-stone-200 rounded-lg p-6">
        {fields.map(([name, label, placeholder, type]) => (
          <label key={name} className={name === 'contact_address' ? 'md:col-span-2' : ''}><span className="field-label">{label}{name !== 'contact_email_secondary' && ' *'}</span><input type={type} required={name !== 'contact_email_secondary'} value={form[name]} placeholder={placeholder} onChange={event => setForm({ ...form, [name]: event.target.value })} className="form-input" /></label>
        ))}
        <label><span className="field-label">위도 *</span><input type="number" step="any" required value={form.contact_lat} onChange={event => setForm({ ...form, contact_lat: event.target.value })} className="form-input" /></label>
        <label><span className="field-label">경도 *</span><input type="number" step="any" required value={form.contact_lng} onChange={event => setForm({ ...form, contact_lng: event.target.value })} className="form-input" /></label>
      </div>
      <div className="flex items-center justify-between gap-4 mt-5"><p className="text-sm text-stone-600" role="status">{status}</p><button disabled={saving} className="primary-button"><Save size={17} />{saving ? '저장 중...' : '연락처 저장'}</button></div>
    </form>
  );
}
